import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import sweetalert from 'sweetalert2'
import KanBoIcon from 'components/KanBoIcon'
import User from 'components/User'
import BoardUser from '../../User'

export class CardUser extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    requestRemoveUserFromCard: PropTypes.func.isRequired,
    requestMakeUserResponsible: PropTypes.func.isRequired
  }

  renderUserComponent = ({
    intl,
    cardId,
    isResponsible,
    isLastMember,
    id,
    isActive,
    menu,

    requestMakeUserResponsible,
    requestRemoveUserFromCard,

    ...props
  }) => {
    let _menu = []

    if (!isResponsible && isActive) {
      _menu.push({
        icon: <KanBoIcon fixedWidth name='kanbo-16-solid-star' />,
        title: <FormattedMessage id='CARD_PROMOTE_USER' />,
        onClick: () => requestMakeUserResponsible({
          id: cardId,
          userId: id
        })
      })
    }
  
    _menu.push({
      icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
      title: <FormattedMessage id='CARD_REMOVE_USER' />,
      onClick: () => {
        if (isResponsible && !isLastMember) {
          sweetalert({
            text: intl.formatMessage({ id: 'CARD_REMOVE_USER_VALIDATE' }),
            type: 'info'
          })
        } else {
          requestRemoveUserFromCard({
            id: cardId,
            userId: id
          })
        }
      }
    })

    return (
      <User
        {...props}
        id={id}
        isActive={isActive}
        menu={_menu}
      />
    )
  }

  render () {
    return (
      <BoardUser
        {...this.props}
      >
        {this.renderUserComponent}
      </BoardUser>
    )
  }
}

export default injectIntl(CardUser)